import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const TESTIMONIALS = [
  {
    quote: "Practising at home changed everything for me. Yoga has really complemented my strength and running training, and Ophelia makes each session feel like it was written for that exact day.",
    name: "Charlotte, Bathwick",
  },
  {
    quote: "I'd never done yoga before and was nervous about a class. One-to-one in my own living room was the gentlest way to begin.",
    name: "Priya, Oldfield Park",
  },
  {
    quote: "Calm, attentive and completely unhurried. My shoulders haven't felt this good in years.",
    name: "James, Larkhall",
  },
];

const FAQS = [
  {
    q: "Do I need any experience?",
    a: "None at all. Sessions are tailored to exactly where you are — complete beginners are very welcome, as are experienced practitioners.",
  },
  {
    q: "What do I need at home?",
    a: "Just a small clear space, roughly the size of a yoga mat. All equipment — mats, blocks, blankets — is brought to you.",
  },
  {
    q: "Which areas do you cover?",
    a: "Anywhere in Bath. Travel within Bath is included in the hourly rate.",
  },
  {
    q: "How do I book?",
    a: "Send a message on WhatsApp or by email and we'll find a time that suits you. Payment is made simply after each session.",
  },
];

export const Voices = () => (
  <section id="voices" data-testid="voices-section" className="py-28 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="uppercase text-xs sm:text-sm tracking-[0.28em] font-medium text-terracotta" data-testid="voices-overline">
          Kind Words
        </p>
      </Reveal>

      <div className="mt-14 md:mt-20 space-y-16 md:space-y-24">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.05}>
            <figure className={`max-w-3xl ${i % 2 === 1 ? "md:ml-auto md:text-right" : ""}`} data-testid={`testimonial-${i}`}>
              <blockquote className="font-serif italic font-light text-2xl sm:text-3xl lg:text-4xl leading-snug text-olive" data-testid={`testimonial-quote-${i}`}>
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-5 uppercase text-xs tracking-[0.22em] text-olive-soft" data-testid={`testimonial-name-${i}`}>
                {t.name}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <div className="mt-28 md:mt-36 grid grid-cols-1 md:grid-cols-12 gap-10">
        <Reveal className="md:col-span-4">
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight leading-tight" data-testid="faq-heading">
            Gentle<br />questions
          </h2>
        </Reveal>
        <div className="md:col-span-7 md:col-start-6">
          {FAQS.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.08}>
              <details className="group border-t border-olive/10 py-6" data-testid={`faq-item-${i}`}>
                <summary className="flex items-center justify-between cursor-pointer list-none" data-testid={`faq-question-${i}`}>
                  <span className="font-serif text-xl sm:text-2xl font-normal text-olive">{f.q}</span>
                  <Plus className="faq-icon w-5 h-5 shrink-0 text-terracotta transition-transform duration-300" />
                </summary>
                <p className="mt-4 text-base leading-relaxed font-light tracking-wide text-olive-soft max-w-xl" data-testid={`faq-answer-${i}`}>
                  {f.a}
                </p>
              </details>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
